var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMypencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1757471300353,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 5950,
    width: 14,
    height: 14,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M757.385 474.729 341.156 890.958 133.042 890.958 133.042 682.844l416.229-416.229L757.385 474.729zM360.167 781.397 242.602 663.833l-45.525 45.525 0 53.529 64.035 0 0 64.035 53.529 0L360.167 781.397zM565.279 351.662c-3.002 0-6.004 1-8.505 3.502L285.626 626.313c-2.501 2.502-3.502 5.503-3.502 8.505 0 6.504 4.502 11.006 11.006 11.006 3.001 0 6.003-1 8.505-3.502l271.148-271.148c2.502-2.501 3.502-5.503 3.502-8.505C576.285 356.165 571.783 351.662 565.279 351.662zM872.448 359.667l-83.046 83.045L581.288 234.598l83.046-82.545c11.506-12.006 28.015-19.01 45.024-19.01s33.519 7.004 45.525 19.01l117.564 117.064c11.506 12.006 18.51 28.516 18.51 45.525S883.954 348.16 872.448 359.667z",
    "p-id": 5951
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMypencil);
export default __webpack_public_path__ + "static/media/mypencil.51f7218e.svg";
export { ForwardRef as ReactComponent };